export const ROUTES = {
  home: "/",
  create: "/create",
  worksheet: "/:worksheetId",
  grade: "/grade/:worksheetId",
} as const;

export function worksheetPath(worksheetId: string): string {
  return `/${encodeURIComponent(worksheetId)}`;
}

// The token rides in the fragment so it never reaches a server log.
export function gradePath(worksheetId: string, token?: string): string {
  const path = `/grade/${encodeURIComponent(worksheetId)}`;
  return token === undefined ? path : `${path}#${token}`;
}
